@if (offer(); as o) {
	<div class="flex-row title-box">
		@switch (o.type) {
			@case (OffersType.DAYTRIP) {
				<tvcore-ivv-title title="BOOKING.TITLE_DAYTRIP"></tvcore-ivv-title>
			}
			@case (OffersType.ACCOMMODATION) {
				<tvcore-ivv-title title="BOOKING.TITLE_ACCOMMODATION"></tvcore-ivv-title>
			}
			@case (OffersType.ORGANIZED_HOLIDAY) {
				<tvcore-ivv-title title="BOOKING.TITLE_ORGANIZED_HOLIDAY"></tvcore-ivv-title>
			}
		}

		@if (state() !== 'submitted') {
			<button (click)="showCloseBooking.set(true)" class="close-button">
				<span class="u-m-right--xxs">{{ 'BOOKING.CANCEL_BUTTON' | translate }}</span>
				<tvcore-icon name="close"></tvcore-icon>
			</button>
		}
	</div>

	<p class="ivv-sub-title u-m-bottom--md">{{ o.name }}</p>

	@switch (state()) {
		@case ('new') {
			<div class="u-card u-card--float">
				<p class="u-m-bottom--xxs">{{ (o.type === OffersType.ACCOMMODATION ? 'BOOKING.FORM_ACCOMMODATION_DESCRIPTION' : 'BOOKING.FORM_DAYTRIP_DESCRIPTION') | translate }}</p>

				@if (o.hasOwnPage) {
					<button class="c-btn c-btn--blue redirect-btn" (click)="openRedirectUrl()" [disabled]="loadingRedirect()">
						{{ 'BOOKING.FORM_BUTTON' | translate }}
						<tvcore-icon name="external-link"></tvcore-icon>
					</button>
				} @else {
					<button class="c-btn c-btn--blue redirect-btn" (click)="state.set('form')">
						{{ 'BOOKING.FORM_BUTTON' | translate }}
						<tvcore-icon name="arrow"></tvcore-icon>
					</button>
				}

				@if (showGroupBooking()) {
					<div class="u-m-top--sm">
						<p class="u-m-bottom--xxs">{{ (o.type === OffersType.ACCOMMODATION ? 'BOOKING.GROUP_ACCOMMODATION_TITLE' : 'BOOKING.GROUP_DAYTRIP_TITLE') | translate }}</p>

						@if (o.hasOwnGroupPage) {
							<button class="c-btn c-btn--blue redirect-btn" (click)="openRedirectUrl(true)" [disabled]="loadingRedirect()">
								{{ 'BOOKING.GROUP_BUTTON' | translate }}
								<tvcore-icon name="external-link"></tvcore-icon>
							</button>
						} @else {
							<button class="c-btn c-btn--blue redirect-btn" (click)="state.set('group')">
								{{ 'BOOKING.GROUP_BUTTON' | translate }}
								<tvcore-icon name="arrow"></tvcore-icon>
							</button>
						}
					</div>
				}
			</div>

			@if (showDebtMediationMessage()) {
				<tvcore-message color="blue" icon="info" class="u-m-top--md">
					<p>
						Is directe online betaling van een daguitstap niet mogelijk (schuldbemiddeling, bewindvoering, geen bankrekening)? Vraag je reservatiebewijs aan via je sociale
						partnerorganisatie of Rap op Stapkantoor.
					</p>
				</tvcore-message>
			}
		}
		@case ('form') {
			<ivva-form-booking [offer]="o" (submitted)="state.set('submitted')"></ivva-form-booking>
		}
		@case ('group') {
			<ivva-groups-booking [offer]="o" (submitted)="state.set('submitted')"></ivva-groups-booking>
		}
		@case ('submitted') {
			<ivva-booking-submitted [offer]="o"></ivva-booking-submitted>
		}
	}

	<div [class.c-modal--show]="showCloseBooking()" class="c-modal">
		<div class="c-modal__content">
			@if (o.type === OffersType.ACCOMMODATION) {
				<p class="u-title-group u-m-bottom--sm">{{ 'BOOKING.CANCEL_MODAL.TITLE_ACCOMMODATION' | translate }}</p>
				<p>{{ 'BOOKING.CANCEL_MODAL.CONTENT_ACCOMMODATION' | translate }}</p>
			} @else {
				<p class="u-title-group u-m-bottom--sm">{{ 'BOOKING.CANCEL_MODAL.TITLE' | translate }}</p>
				<p>{{ 'BOOKING.CANCEL_MODAL.CONTENT' | translate }}</p>
			}

			<div class="c-modal__buttons">
				<button (click)="showCloseBooking.set(false)" class="c-btn-option">{{ 'BOOKING.CANCEL_MODAL.STAY_BUTTON' | translate }}</button>
				<a [routerLink]="['/', 'offers', id]" class="c-btn c-btn--blue">{{ 'BOOKING.CANCEL_MODAL.CLOSE_BUTTON' | translate }}</a>
			</div>
		</div>
	</div>

	<div [class.c-modal--show]="redirectUrl()" class="c-modal">
		<div class="c-modal__content">
			<p class="u-title-group u-m-bottom--sm">De link is geopend in een nieuw tabblad</p>
			<p>Zie je geen nieuw tabblad? Mogelijk blokkeert je browser pop-ups.</p>
			<br />
			<p>Klik hieronder om de link handmatig te openen:</p>
			@if (redirectUrl(); as url) {
				<a [href]="url" target="_blank">{{ url }}</a>
			}
			<div class="c-modal__buttons c-modal__buttons--center">
				<button (click)="redirectUrl.set(null)" class="c-btn c-btn--blue">Sluiten</button>
			</div>
		</div>
	</div>
}
